import { AlertDialog } from '@economic/taco';
import { Trans } from '@lingui/macro';
import type { CompanyResponse } from '~/payment-cards-feature';
import { CompanySettingsButton } from './CompanySettingsButton';

export const CannotValidateCompanyDialog = ({
    onSettingsSaved,
    currentCompanyData,
}: {
    onSettingsSaved: () => void;
    currentCompanyData: CompanyResponse;
}) => {
    return (
        <AlertDialog defaultOpen>
            <AlertDialog.Content aria-label="Cannot validate company">
                <AlertDialog.Title>
                    <Trans>Error</Trans>
                </AlertDialog.Title>
                <div className="my-6">
                    <p className="text-grey-700 m-0">
                        <Trans>We cannot validate your company. Check your company registration number (CVR or SE number)</Trans>
                    </p>
                </div>
                <AlertDialog.Footer>
                    <CompanySettingsButton onSettingsSaved={onSettingsSaved} currentCompanyData={currentCompanyData} />
                </AlertDialog.Footer>
            </AlertDialog.Content>
        </AlertDialog>
    );
};
